import React from 'react';
import { XCircle } from 'lucide-react';

const CancelTournamentModal = ({ 
  tournament, 
  reason, 
  setReason, 
  onConfirm, 
  onCancel, 
  loading, 
  language, 
  t 
}) => {
  if (!tournament) return null;

  const isGiveaway = tournament.tournamentType === 'giveaway';
  const participantCount = tournament.participants?.length || 0;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <div className="modal-icon">
            <XCircle className="w-6 h-6 text-white" />
          </div>
          <h3 className="modal-title">{t('cancelTournament', language)}</h3>
        </div>
        
        <div className="modal-body">
          <div className="modal-user-info">
            <p className="modal-user-name">
              {tournament.creator?.inGameName || 'Unknown'}'s {tournament.gameMode} {t('tournaments', language)}
            </p>
            <p className="modal-user-email">{t('status', language)}: {tournament.status}</p>
            <p className="modal-user-email">
              {t('participants', language)}: {participantCount}/{tournament.maxPlayers}
            </p>
            <p className="modal-user-email">
              {t('prizePool', language)}: {tournament.prizePool} {t('points', language)}
            </p>
            {isGiveaway && <p className="modal-user-email">{t('giveawayTournament', language)}</p>}
          </div>

          <div className="modal-warning">
            <p className="modal-warning-text">
              <strong>{t('refundInformation', language)}</strong><br/>
              {isGiveaway ? (
                `Creator will receive ${tournament.giveawayData?.totalCreatorCost || tournament.prizePool} points`
              ) : (
                `Each participant will receive ${tournament.entryFee} points (total: ${tournament.entryFee * participantCount})`
              )}
            </p>
          </div>

          <div>
            <label className="role-reason-label">
              {t('cancellationReason', language)}
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder={t('enterReasonForCancelling', language)}
              className="role-reason-textarea"
              rows={3}
            />
          </div>

          <div className="modal-warning">
            <p className="modal-warning-text">
              {t('thisActionCannotBeUndone', language) || 'This action cannot be undone.'}
            </p>
          </div>
        </div>
        
        <div className="modal-actions">
          <button
            onClick={onConfirm}
            disabled={loading}
            className="modal-btn modal-btn-danger"
          >
            {loading ? t('cancelling', language) : t('confirmCancellation', language)}
          </button>
          <button
            onClick={onCancel}
            disabled={loading}
            className="modal-btn modal-btn-secondary"
          >
            {t('keepTournament', language)}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelTournamentModal;